<template>
  <AppLink :to="url" target="_blank" :rel="rel">
    <ArticleContentRenderer v-if="children" :content="children" :preloaded-data="preloadedData" />
  </AppLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import ArticleContentRenderer from './ArticleContentRenderer.vue';

import type { PreloadedData } from './lib/articleComponents';
import type { ArticleContent } from './models/ArticleContent';

export interface Props {
  url: string;
  linkType?: 'external' | 'internal';
  children?: ArticleContent;
  preloadedData: PreloadedData;
}

const props = defineProps<Props>();

const rel = computed(() => (props.linkType === 'external' ? 'nofollow noreferrer noopener' : undefined));
</script>
